var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Card, Flex, Skeleton, theme, Typography, } from '@robinpowered/ui-kit';
import { SpaceDetails } from './SpaceDetails';
import { WorkplaceServiceRequestWrapper } from '../WorkplaceService/WorkplaceServiceRequestWrapper';
import { Buffers } from '../Buffers/Buffers';
import { SpaceInfoWrapper } from './EventSpaceWrapper';
import { useWatch } from 'react-hook-form';
import { useConfig } from '../../context/ConfigContext';
import { useSpaceConflictDetection } from './hooks/useSpaceConflictDetection';
import { faExclamationCircle } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEventApi } from '../../hooks/useEvent/useEventApi';
import { useSpaceDetailsContext } from './SpaceDetailsContext';
import { useEventComposerGlobalContext } from '../../composers/EventComposerGlobalContext';
import { useSpaceActions } from './Actions/SpaceActions';
import { useAdvancedBookingThreshold } from '../../hooks/useAdvancedBookingThreshold';
export var SpaceComponent = function (_a) {
    var _b, _c;
    var spaceId = _a.spaceId, spaceInviteeId = _a.spaceInviteeId, userCanRemoveSpace = _a.userCanRemoveSpace, onChangeSpace = _a.onChangeSpace;
    var tSpaceBooking = useTranslation('spaceBooking').t;
    var _d = useSpaceDetailsContext(), showMeetingBuffers = _d.showMeetingBuffers, featureFlagsLoading = _d.loading, initialEvent = _d.initialEvent;
    var token = theme.useToken().token;
    var onError = useEventComposerGlobalContext().onError;
    var _e = useConfig(), accessToken = _e.accessToken, environmentUrls = _e.environmentUrls, tenantId = _e.tenantId, userContext = _e.userContext;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var _f = __read(useWatch({
        name: ['spaceBuffers', 'spacesWithConflicts'],
    }), 2), spaceBuffers = _f[0], spacesWithConflicts = _f[1];
    var conflictingSpaceIds = useAdvancedBookingThreshold().conflictingSpaceIds;
    var hasAbtConflict = conflictingSpaceIds.includes(spaceId);
    var getEventsBySpaceId = useEventApi({
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).getEventsBySpaceId;
    useSpaceConflictDetection({
        spaceId: spaceId,
        spaceBuffers: spaceBuffers,
        apiUrl: apiUrl,
        accessToken: accessToken,
        onError: onError,
        getEventsBySpaceId: getEventsBySpaceId,
    });
    var spaceActions = useSpaceActions({
        initialSpaceIds: initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.spaceIds,
        spaceId: spaceId,
        spaceInviteeId: spaceInviteeId,
        onChangeSpace: onChangeSpace,
        userCanRemoveSpace: userCanRemoveSpace,
    });
    return (_jsxs(_Fragment, { children: [_jsxs(SpaceWrapper, { style: __assign({ borderRadius: '4px', padding: '0px' }, ((((_b = spacesWithConflicts === null || spacesWithConflicts === void 0 ? void 0 : spacesWithConflicts[spaceId]) === null || _b === void 0 ? void 0 : _b.eventTime) || hasAbtConflict) && {
                    border: "1px solid ".concat(token.colorErrorBorder),
                })), styles: {
                    body: {
                        padding: '0px',
                    },
                    actions: {
                        padding: token.paddingXS,
                        background: token.colorBgLayout,
                    },
                }, actions: spaceActions, token: token, children: [_jsx(SpaceDetails, { spaceId: spaceId }), featureFlagsLoading ? (_jsx(SpaceInfoWrapper, { showBorder: false, children: _jsx(Skeleton.Button, { size: "small", active: true, block: true }) })) : (showMeetingBuffers && _jsx(Buffers, { spaceId: spaceId })), _jsx(WorkplaceServiceRequestWrapper, { spaceId: spaceId })] }), ((_c = spacesWithConflicts === null || spacesWithConflicts === void 0 ? void 0 : spacesWithConflicts[spaceId]) === null || _c === void 0 ? void 0 : _c.eventTime) && (_jsxs(Flex, { align: "center", gap: "4px", children: [_jsx(FontAwesomeIcon, { icon: faExclamationCircle, color: token.colorError }), _jsx(ErrorText, { style: { color: token.colorError }, children: tSpaceBooking('space_unavailable') })] })), hasAbtConflict && (_jsxs(Flex, { align: "center", gap: "4px", children: [_jsx(FontAwesomeIcon, { icon: faExclamationCircle, color: token.colorError }), _jsx(ErrorText, { style: { color: token.colorError }, children: tSpaceBooking('advanced_booking_threshold_conflict') })] }))] }));
};
var SpaceWrapper = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-card-actions {\n    li {\n      margin: 0px;\n    }\n  }\n"], ["\n  .ant-card-actions {\n    li {\n      margin: 0px;\n    }\n  }\n"])));
var ErrorText = styled(Typography.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  margin-left: 4px;\n"], ["\n  display: block;\n  margin-left: 4px;\n"])));
var templateObject_1, templateObject_2;
